export const Calculations = ({
  dailyTravelKm = 60,
  getTotalSavings,
  fuelCost,
}) => {
  const DAYS_IN_YEAR = 336;
  const WEEKS_IN_YEAR = 48;

  var years = 1;

  function getTotalCost(ownershipCost, yearlyMaintainanceCharges) {
    var totalCost =
      ownershipCost +
      dailyTravelKm * (fuelCost / mileage) * DAYS_IN_YEAR +
      yearlyMaintainanceCharges;
    return totalCost;
  }

  // Diesel
  var mileage = 29;

  var ownershipCost = 430567;
  var yearlyMaintainanceCharges = 18816.0;
  var yearlyConnectivityCharges = 0;

  var yearlyRunningCost;

  function getYearlyRunningCostTraditional(dailyTravelKm, mileage, fuelCost) {
    yearlyRunningCost =
      dailyTravelKm * (fuelCost / mileage) * DAYS_IN_YEAR +
      yearlyMaintainanceCharges;
    return yearlyRunningCost;
  }

  console.log("\nDiesel Vehicle");
  console.log(
    "Yearly Running Cost:" +
      getYearlyRunningCostTraditional(dailyTravelKm, mileage, fuelCost)
  );

  let traditionalCost = yearWiseCostEV(
    years,
    ownershipCost,
    yearlyRunningCost,
    yearlyMaintainanceCharges,
    yearlyConnectivityCharges
  );

  // EV
  var fuelCostElectric = 6;
  var mileage = 27;
  var range = 12;
  var batteryCapacity = 10.43;

  var ownershipCost = 489320;
  var yearlyMaintainanceCharges = 6451;
  var yearlyConnectivityCharges = 1000;

  var yearlyRunningCost;

  function getYearlyRunningCostEV(
    dailyTravelKm,
    batteryCapacity,
    range,
    fuelCostElectric
  ) {
    yearlyRunningCost =
      dailyTravelKm * (fuelCostElectric / range) * DAYS_IN_YEAR +
      yearlyMaintainanceCharges;
    return yearlyRunningCost;
  }

  console.log("\nElectric Vehicle");
  console.log(
    "Yearly Running Cost:" +
      getYearlyRunningCostEV(
        dailyTravelKm,
        batteryCapacity,
        range,
        fuelCostElectric
      )
  );
  console.log(
    "Total Cost:" + getTotalCost(ownershipCost, yearlyMaintainanceCharges)
  );
  console.log(
    "After " +
      years +
      " EV Cost:" +
      yearWiseCostEV(
        years,
        ownershipCost,
        yearlyRunningCost,
        yearlyMaintainanceCharges,
        yearlyConnectivityCharges
      )
  );
  let EVCost = yearWiseCostEV(
    years,
    ownershipCost,
    yearlyRunningCost,
    yearlyMaintainanceCharges,
    yearlyConnectivityCharges
  );

  //EV Yearwise Cost
  function yearWiseCostEV(
    years,
    ownershipCost,
    yearlyRunningCost,
    yearlyMaintainanceCharges,
    yearlyConnectivityCharges
  ) {
    var totalCost = ownershipCost;
    for (var year = 1; year <= years; year++) {
      totalCost +=
        yearlyRunningCost +
        yearlyMaintainanceCharges +
        yearlyConnectivityCharges;
    }
    return totalCost;
  }

  getTotalSavings({
    yearly: Number(traditionalCost - EVCost).toFixed(0),
    weekly: Number((traditionalCost - EVCost) / WEEKS_IN_YEAR).toFixed(0),
    daily: Number((traditionalCost - EVCost) / DAYS_IN_YEAR).toFixed(0),
  });
  return <div />;
};
